"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _proRegularSvgIcons = require("@fortawesome/pro-regular-svg-icons");

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

var DeleteFieldButton = function DeleteFieldButton(_ref) {
  var questionName = _ref.questionName,
      onDeleteQuestion = _ref.onDeleteQuestion;

  var _useState = (0, _react.useState)(false),
      showDeleteModal = _useState[0],
      setShowDeleteModal = _useState[1];

  var handleDeleteQuestion = function handleDeleteQuestion() {
    setShowDeleteModal(false);
    onDeleteQuestion();
  };

  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "float-left"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Button, {
      variant: null,
      onClick: function onClick() {
        return setShowDeleteModal(true);
      },
      "data-cy": "delete-button",
      className: "float-left btn-outline-danger",
      style: {
        paddingTop: '10px',
        paddingBottom: '10px'
      }
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      className: "fal float-left",
      icon: _proRegularSvgIcons.faTrashAlt,
      style: {
        color: '#f7473f'
      },
      "aria-label": "delete-field"
    })),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Modal, {
      show: showDeleteModal,
      onHide: function onHide() {
        return setShowDeleteModal(false);
      },
      className: "modal",
      centered: true
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Modal.Header, {
      closeButton: true,
      onClick: function onClick() {
        return setShowDeleteModal(false);
      }
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Modal.Title, null, "Delete Form Field")),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Modal.Body, null, "Do you want to delete\xA0", questionName || '', "?"),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Modal.Footer, null,
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Button, {
      variant: "secondary",
      onClick: function onClick() {
        return setShowDeleteModal(false);
      }
    }, "Cancel"),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Button, {
      variant: "danger",
      onClick: handleDeleteQuestion,
      "data-cy": "delete-modal-button"
    }, "Delete"))))
  );
};

DeleteFieldButton.defaultProps = {
  questionName: ''
};
DeleteFieldButton.propTypes = process.env.NODE_ENV !== "production" ? {
  questionName: _propTypes["default"].string,
  onDeleteQuestion: _propTypes["default"].func.isRequired
} : {};

var _default = exports["default"] = DeleteFieldButton;